import { Box, Typography } from '@material-ui/core'

import { getAllLegends } from '../../config/legends-config'
import { useStyles } from './styles'

export const LegendsBox = () => {
  const classes = useStyles()
  const legends = getAllLegends()

  return (
    <Box className={classes.legendsBox}>
      <Typography variant='body2' className={classes.legendsBoxTitle}>
        Análise comparativa
      </Typography>
      {legends.map(({ key, label, ...style }) => (
        <Box key={key} className={classes.legendsBoxItem}>
          <Box className={classes.styleIdentifier} style={style} />
          <Typography variant='body2'>{label}</Typography>
        </Box>
      ))}
    </Box>
  )
}
